export class Item_Seleccion {
    id: string;
    descripcion: string;
}